import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./settings.css";

import {
getAccountLinks,
saveAccountLinks,
} from "../../pages/api/accountLinksApi.js";

export default function UserSettings() {
const [user, setUser] = useState(null);

const [form, setForm] = useState({
username: "",
email: "",
password: "",
confirmPassword: "",
darkMode: true,


discord: "",
youtube: "",
website: "",


});

const [message, setMessage] = useState({
type: "",
text: "",
});

const [loadingAccounts, setLoadingAccounts] = useState(true);

useEffect(() => {
try {
const storedUser = localStorage.getItem("user");


  if (storedUser) {
    const parsedUser = JSON.parse(storedUser);

    setUser(parsedUser);

    setForm({
      username: parsedUser.username || "",
      email: parsedUser.email || "",
      password: "",
      confirmPassword: "",
      darkMode:
        parsedUser.darkMode !== undefined
          ? parsedUser.darkMode
          : true,

      discord: "",
      youtube: "",
      website: "",
    });

    loadAccountLinks(parsedUser.username);
  } else {
    setLoadingAccounts(false);
  }
} catch (error) {
  console.error("Failed to load user settings:", error);
  setLoadingAccounts(false);
}


}, []);

const loadAccountLinks = async (username) => {
if (!username) {
setLoadingAccounts(false);
return;
}


try {
  const data = await getAccountLinks(username);

  if (data.success) {
    setForm((previous) => ({
      ...previous,
      discord: data.accounts?.discord || "",
      youtube: data.accounts?.youtube || "",
      website: data.accounts?.website || "",
    }));
  }
} catch (error) {
  console.error("Failed to load account links:", error);
} finally {
  setLoadingAccounts(false);
}


};

const handleChange = (e) => {
const { name, value, type, checked } = e.target;


setForm((previous) => ({
  ...previous,
  [name]: type === "checkbox" ? checked : value,
}));

setMessage({
  type: "",
  text: "",
});


};

const handleSubmit = async (e) => {
e.preventDefault();


setMessage({
  type: "",
  text: "",
});

if (!form.username.trim()) {
  setMessage({
    type: "error",
    text: "Please enter a username.",
  });
  return;
}

if (!form.email.trim()) {
  setMessage({
    type: "error",
    text: "Please enter an email address.",
  });
  return;
}

if (form.password && form.password.length < 8) {
  setMessage({
    type: "error",
    text: "Your new password must be at least 8 characters long.",
  });
  return;
}

if (form.password !== form.confirmPassword) {
  setMessage({
    type: "error",
    text: "Passwords do not match.",
  });
  return;
}

try {
  const updatedUser = {
    ...user,
    username: form.username.trim(),
    email: form.email.trim(),
    darkMode: form.darkMode,
  };

  /*
   * Save normal settings locally.
   */
  localStorage.setItem(
    "user",
    JSON.stringify(updatedUser)
  );

  setUser(updatedUser);

  /*
   * Save linked accounts to MySQL.
   */
  const accountResponse = await saveAccountLinks(
    form.username.trim(),
    {
      discord: form.discord.trim(),
      youtube: form.youtube.trim(),
      website: form.website.trim(),
    }
  );

  if (!accountResponse.success) {
    setMessage({
      type: "error",
      text:
        accountResponse.message ||
        "Account settings saved, but account links could not be saved.",
    });

    return;
  }

  setForm((previous) => ({
    ...previous,
    password: "",
    confirmPassword: "",
  }));

  setMessage({
    type: "success",
    text: "Your settings have been saved successfully.",
  });

} catch (error) {
  console.error("Failed to save settings:", error);

  setMessage({
    type: "error",
    text: "Unable to save your settings.",
  });
}


};

const handleLogout = () => {
localStorage.removeItem("user");
window.location.href = "/login";
};

if (!user) {
return ( <div className="settings-container"> <div className="settings-loading"> <i className="fa-solid fa-spinner fa-spin"></i> <p>Loading your settings...</p> </div> </div>
);
}

return ( <div className="settings-container"> <div className="settings-wrapper">


    {/* =================================
        HEADER
    ================================= */}

    <div className="settings-header">
      <div>
        <span className="settings-label">
          ACCOUNT SETTINGS
        </span>

        <h1>Settings</h1>

        <p>
          Manage your Vortex Network account and preferences.
        </p>
      </div>

      <Link to="/profile" className="back-profile-btn">
        <i className="fa-solid fa-arrow-left"></i>
        Back to Profile
      </Link>
    </div>


    {/* =================================
        NOTIFICATION
    ================================= */}

    {message.text && (
      <div
        className={`settings-message ${
          message.type === "success"
            ? "success"
            : "error"
        }`}
      >
        <i
          className={
            message.type === "success"
              ? "fa-solid fa-circle-check"
              : "fa-solid fa-circle-exclamation"
          }
        ></i>

        <span>{message.text}</span>
      </div>
    )}


    <form onSubmit={handleSubmit}>

      {/* =================================
          ACCOUNT
      ================================= */}

      <div className="settings-card">

        <div className="settings-section-header">

          <div>
            <span className="settings-section-label">
              ACCOUNT
            </span>

            <h2>Account Information</h2>

            <p>
              Update the information associated with your account.
            </p>
          </div>

          <i className="fa-solid fa-user"></i>

        </div>


        <div className="settings-grid">

          <div className="settings-field">

            <label htmlFor="username">
              Username
            </label>

            <div className="settings-input-wrapper">

              <i className="fa-solid fa-user"></i>

              <input
                id="username"
                type="text"
                name="username"
                value={form.username}
                onChange={handleChange}
                placeholder="Enter your username"
                autoComplete="username"
              />

            </div>

          </div>


          <div className="settings-field">

            <label htmlFor="email">
              Email Address
            </label>

            <div className="settings-input-wrapper">

              <i className="fa-solid fa-envelope"></i>

              <input
                id="email"
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Enter your email"
                autoComplete="email"
              />

            </div>

          </div>

        </div>

      </div>


      {/* =================================
          PASSWORD
      ================================= */}

      <div className="settings-card">

        <div className="settings-section-header">

          <div>
            <span className="settings-section-label">
              SECURITY
            </span>

            <h2>Password</h2>

            <p>
              Change your account password.
            </p>
          </div>

          <i className="fa-solid fa-lock"></i>

        </div>


        <div className="settings-grid">

          <div className="settings-field">

            <label htmlFor="password">
              New Password
            </label>

            <div className="settings-input-wrapper">

              <i className="fa-solid fa-lock"></i>

              <input
                id="password"
                type="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="Enter a new password"
                autoComplete="new-password"
              />

            </div>

            <small>
              Leave blank if you don't want to change your password.
            </small>

          </div>


          <div className="settings-field">

            <label htmlFor="confirmPassword">
              Confirm Password
            </label>

            <div className="settings-input-wrapper">

              <i className="fa-solid fa-shield-halved"></i>

              <input
                id="confirmPassword"
                type="password"
                name="confirmPassword"
                value={form.confirmPassword}
                onChange={handleChange}
                placeholder="Confirm your new password"
                autoComplete="new-password"
              />

            </div>

          </div>

        </div>

      </div>


      {/* =================================
          APPEARANCE
      ================================= */}

      <div className="settings-card">

        <div className="settings-section-header">

          <div>
            <span className="settings-section-label">
              PREFERENCES
            </span>

            <h2>Appearance</h2>

            <p>
              Customize how the Vortex Network website looks.
            </p>
          </div>

          <i className="fa-solid fa-palette"></i>

        </div>


        <label className="settings-toggle">

          <div className="toggle-icon">
            <i className="fa-solid fa-moon"></i>
          </div>

          <div className="toggle-content">

            <strong>Dark Mode</strong>

            <span>
              Use the dark Vortex Network theme.
            </span>

          </div>


          <div className="toggle-switch">

            <input
              type="checkbox"
              name="darkMode"
              checked={form.darkMode}
              onChange={handleChange}
            />

            <span className="toggle-slider"></span>

          </div>

        </label>

      </div>


      {/* =================================
          LINKED ACCOUNTS
      ================================= */}

      <div className="settings-card">

        <div className="settings-section-header">

          <div>
            <span className="settings-section-label">
              SOCIAL
            </span>

            <h2>Linked Accounts</h2>

            <p>
              Add your social media and website links to your Vortex profile.
            </p>
          </div>

          <i className="fa-solid fa-link"></i>

        </div>


        {loadingAccounts ? (

          <div className="settings-loading">
            <i className="fa-solid fa-spinner fa-spin"></i>
            <p>Loading linked accounts...</p>
          </div>

        ) : (

          <div className="settings-accounts">

            {/* DISCORD */}

            <div className="settings-account">

              <div className="settings-account-header">

                <div className="settings-account-icon discord-icon">
                  <i className="fa-brands fa-discord"></i>
                </div>

                <div>
                  <strong>Discord</strong>

                  <span
                    className={
                      form.discord
                        ? "account-status linked"
                        : "account-status"
                    }
                  >
                    {form.discord
                      ? "Linked"
                      : "Not linked"}
                  </span>
                </div>

              </div>


              <div className="settings-input-wrapper">

                <i className="fa-brands fa-discord"></i>

                <input
                  type="url"
                  name="discord"
                  value={form.discord}
                  onChange={handleChange}
                  placeholder="https://discord.gg/..."
                />

              </div>

            </div>


            {/* YOUTUBE */}

            <div className="settings-account">

              <div className="settings-account-header">

                <div className="settings-account-icon youtube-icon">
                  <i className="fa-brands fa-youtube"></i>
                </div>

                <div>
                  <strong>YouTube</strong>

                  <span
                    className={
                      form.youtube
                        ? "account-status linked"
                        : "account-status"
                    }
                  >
                    {form.youtube
                      ? "Linked"
                      : "Not linked"}
                  </span>
                </div>

              </div>


              <div className="settings-input-wrapper">

                <i className="fa-brands fa-youtube"></i>

                <input
                  type="url"
                  name="youtube"
                  value={form.youtube}
                  onChange={handleChange}
                  placeholder="https://youtube.com/@..."
                />

              </div>

            </div>


            {/* WEBSITE */}

            <div className="settings-account">

              <div className="settings-account-header">

                <div className="settings-account-icon website-icon">
                  <i className="fa-solid fa-globe"></i>
                </div>

                <div>
                  <strong>Website</strong>

                  <span
                    className={
                      form.website
                        ? "account-status linked"
                        : "account-status"
                    }
                  >
                    {form.website
                      ? "Set"
                      : "Not set"}
                  </span>
                </div>

              </div>


              <div className="settings-input-wrapper">

                <i className="fa-solid fa-globe"></i>

                <input
                  type="url"
                  name="website"
                  value={form.website}
                  onChange={handleChange}
                  placeholder="https://example.com"
                />

              </div>

            </div>

          </div>

        )}

      </div>


      {/* =================================
          SAVE
      ================================= */}

      <div className="settings-save">

        <button
          type="submit"
          className="save-settings-btn"
        >
          <i className="fa-solid fa-floppy-disk"></i>
          Save Settings
        </button>

      </div>

    </form>


    {/* =================================
        DANGER ZONE
    ================================= */}

    <div className="settings-card danger-zone">

      <div className="settings-section-header">

        <div>
          <span className="settings-section-label danger-label">
            ACCOUNT
          </span>

          <h2>Account Actions</h2>

          <p>
            Manage your current Vortex Network session.
          </p>
        </div>

        <i className="fa-solid fa-triangle-exclamation"></i>

      </div>


      <div className="danger-content">

        <div>

          <strong>
            Log out of your account
          </strong>

          <p>
            You will need to sign in again to access your account.
          </p>

        </div>


        <button
          type="button"
          className="settings-logout-btn"
          onClick={handleLogout}
        >
          <i className="fa-solid fa-right-from-bracket"></i>
          Log Out
        </button>

      </div>

    </div>

  </div>
</div>


);
}
